// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file booking_gateway/v1/vouchers.proto (package booking_gateway.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Discount, LineItem } from "../../voucher/types/v1/usage_pb.js";
import { Money } from "../../types/v1/money_pb.js";
import { ActiveBenefit, Association } from "../../voucher/types/v1/membership_pb.js";

/**
 * @generated from message booking_gateway.v1.GetVoucherByCodeRequest
 */
export const GetVoucherByCodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.GetVoucherByCodeRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking_gateway.v1.GetVoucherByCodeResponse
 */
export const GetVoucherByCodeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.GetVoucherByCodeResponse",
  () => [
    { no: 1, name: "voucher", kind: "message", T: Voucher, oneof: "token" },
    { no: 2, name: "giftcard", kind: "message", T: Giftcard, oneof: "token" },
  ],
);

/**
 * @generated from message booking_gateway.v1.RedeemVoucherRequest
 */
export const RedeemVoucherRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.RedeemVoucherRequest",
  () => [
    { no: 1, name: "voucher_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "line_item", kind: "message", T: LineItem, opt: true },
  ],
);

/**
 * @generated from message booking_gateway.v1.RedeemVoucherResponse
 */
export const RedeemVoucherResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.RedeemVoucherResponse",
  [],
);

/**
 * @generated from message booking_gateway.v1.ReleaseVoucherRequest
 */
export const ReleaseVoucherRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.ReleaseVoucherRequest",
  () => [
    { no: 1, name: "voucher_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking_gateway.v1.ReleaseVoucherResponse
 */
export const ReleaseVoucherResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.ReleaseVoucherResponse",
  [],
);

/**
 * @generated from message booking_gateway.v1.Voucher
 */
export const Voucher = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.Voucher",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "discount", kind: "message", T: Discount },
    { no: 9, name: "event_series_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "price_group_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "price_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "bundle_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message booking_gateway.v1.Giftcard
 */
export const Giftcard = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.Giftcard",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "balance", kind: "message", T: Money },
    { no: 4, name: "expires_at", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * @generated from message booking_gateway.v1.RedeemBenefitRequest
 */
export const RedeemBenefitRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.RedeemBenefitRequest",
  () => [
    { no: 2, name: "benefit_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "association", kind: "enum", T: proto3.getEnumType(Association) },
    { no: 4, name: "membership_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "line_item", kind: "message", T: LineItem, opt: true },
  ],
);

/**
 * @generated from message booking_gateway.v1.RedeemBenefitResponse
 */
export const RedeemBenefitResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.RedeemBenefitResponse",
  [],
);

/**
 * @generated from message booking_gateway.v1.GetActiveBenefitsRequest
 */
export const GetActiveBenefitsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.GetActiveBenefitsRequest",
  [],
);

/**
 * @generated from message booking_gateway.v1.GetActiveBenefitsResponse
 */
export const GetActiveBenefitsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.GetActiveBenefitsResponse",
  () => [
    { no: 1, name: "benefits", kind: "message", T: ActiveBenefit, repeated: true },
  ],
);

/**
 * @generated from message booking_gateway.v1.ReleaseBenefitRequest
 */
export const ReleaseBenefitRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.ReleaseBenefitRequest",
  () => [
    { no: 1, name: "benefit_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking_gateway.v1.ReleaseBenefitResponse
 */
export const ReleaseBenefitResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.ReleaseBenefitResponse",
  [],
);

